import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=724dea6d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=724dea6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724dea6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724dea6d')) {
      api.createRecord('724dea6d', component.options)
    } else {
      api.reload('724dea6d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=724dea6d&scoped=true&", function () {
      api.rerender('724dea6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ozk4036Zrazi/JS/comp/GuestBox.vue"
export default component.exports